import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Message } from 'src/app/shared/models/app.models';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { UserService } from 'src/app/shared/services/user.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FormValidationService } from 'src/app/shared/services/form-validation.service';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';
import { BaseResponseDTO } from '../models/app.models';
import { lastValueFrom } from 'rxjs';
import { AppConstants } from 'src/app/shared/constants/app.contants';

@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})

export class MessageComponent implements OnInit {
  @ViewChild('chatBody') chatBody: ElementRef;

  messages: Message[] = [
    
  ];





  selectedMessage: Message | null = null;
  relatedMessages: Message[] = [];
  filteredMessages: Message[] = [];
  searchQuery: string = '';
  form: FormGroup;


  constructor(
    private _router: Router,
    private _activeRoute : ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _http: HttpClient,
    private _dialogService: DialogService,
    private _loaderService: LoaderService,
    private _userService: UserService,
    private formValidationService: FormValidationService,
    private fb: FormBuilder,

  ) { 

  }


  scrollToBottom(): void {
    try {
      const chatBodyElement = this.chatBody.nativeElement;
      chatBodyElement.scrollTop = chatBodyElement.scrollHeight;
    } catch (err) {
      console.error('Error scrolling to the bottom:', err);
    }
  }

ngAfterViewChecked() {
  //this.scrollToBottom();

}


  ngOnInit() {

    console.log("MESSAGES # 1 " + JSON.stringify(this.messages));

    // Find the index of the first general message (referenceNumber is null)
        this.form = this.fb.group({
          search: [''],
          message: ['']  // Initialize message input with an empty string
        });
       // Subscribe to changes in the search control value
       this.form.get('search')?.valueChanges.subscribe((searchValue: string) => {
        this.filterMessages(searchValue);
    });
            // Await for messages to be fetched before proceeding
          this.getMessages().then(() => {
   
        });

  }
  //#region  helpers methods 

  

  async getMessages() {

    



      const apiService = this.createApiService();

      new Promise((resolve, reject) => {
        this._loaderService.showLoader();

          this.fireGetMessage(apiService)
          .then((result: any) => {
            let response: BaseResponseDTO = result;
  
            if (response?.isSuccess){
       
                        // Assuming the data from backend is stored in `result.result`
                        const backendMessages: any[] = result.data;


                            //   direction: 'Outbound',
                          //   moudle: 'General',
                          //   vendorID: '12345',
                          //   subReferenceNumber: 10003,
                          //   referenceNumber: null, // General message
                          //   messageContent: 'Waiting for your responses.',
                          //   CreatedAt: new Date(2023, 9, 10, 10, 0).toISOString(), // September 20, 2023 at 10:00 AM
                          // },


                        // Mapping backend messages to the local `Message` array
                        this.messages =
                          backendMessages.map((backendMsg) => {
                            const serverTime = new Date(backendMsg.createdAt);
                            const localTime = new Date(serverTime.getTime() - serverTime.getTimezoneOffset() * 60000);
                        
                            return {
                              direction: backendMsg.direction || 'Outbound', // Default if direction is missing
                              moudle: backendMsg.moudle || 'General',
                              subReferenceNumber: backendMsg.subReferenceNumber,
                              referenceNumber: backendMsg.referenceNumber,
                              processID: backendMsg.processID,
                              messageContent: backendMsg.messageContent,
                              CreatedAt: new Date(backendMsg.createdAt).toISOString(), // Ensure proper date format
                            };
                          })
                        
                        
                        console.log("BACKEND - MESSAGES " + JSON.stringify(backendMessages));

   
                        console.log("MESSAGES " + JSON.stringify(this.messages));

                    
                  

                         this.filterMessages('');
                          // Set the selected message to the first one if available
                          if (this.messages.length > 0) {
                            this.selectMessage(this.messages[0]);
                          }
                        // this.messages.filter(message => {
                        //   message.moudle =  message.referenceNumber === null ? message.moudle : message.moudle + ' - ' + message.referenceNumber;
                        // });
     


                
            
              // // Add the new message to the list of messages
              // this.messages.push(newMessage);


              // // Update the relatedMessages array to show the new message immediately
              // if (this.selectedMessage?.referenceNumber === newMessage.referenceNumber || 
              //   (!this.selectedMessage?.referenceNumber && !newMessage.referenceNumber)) {
              // this.relatedMessages.push(newMessage);
              // }

            }
          
            resolve(response);
  
          }).catch((err: HttpErrorResponse) => {
              this._loaderService.hideLoader();
          }).finally(() =>{
              this._loaderService.hideLoader();
          });
  
      });



  }


  

  getModuleDisplayName(message: any, includeModule: boolean | null = null): string {
    if (includeModule === null) {
      // Default behavior: Return the full message
      if (message.moudle === 'VendorChat') {
        return 'General';
      } else if (message.moudle === 'BiddingChat') {
        return `Bid Chat - ${message.referenceNumber || ''}`;
      } else if (message.moudle === 'PurchInvoiceChat') {
        return `Invoice Chat - ${message.referenceNumber || ''} - ${message.processID|| ''}`;
      } else {
        return message.moudle || 'Unknown Module';
      }
    } else if (includeModule === true) {
      // Only take the module part
      if (message.moudle === 'VendorChat') {
        return 'General';
      } else if (message.moudle === 'BiddingChat') {
        return 'Bid Chat';
      } else if (message.moudle === 'PurchInvoiceChat') {
        return 'Invoice Chat';
      } else {
        return message.moudle || 'Unknown Module';
      }
    } else {
      // Only take the reference and sub-reference parts
      const reference = message.referenceNumber || '';
      const subReference = message.processID ? ` - ${message.processID}` : '';
      return `${reference}${subReference}`;
    }
  }
  
  

async loadMessages() {
  const seenGeneralMessages = new Set(); // Keep track of seen general messages

  this.filteredMessages = this.messages.filter((message) => {
    if (message.moudle === 'VendorChat') {
      // If it's a general message and we haven't seen it yet
      if (!seenGeneralMessages.has(message.moudle)) {
        seenGeneralMessages.add(message.moudle);
        return true;
      }
      return false; // Skip duplicate general messages
    } else {
      // For non-general messages, just display them
      return true;
    }
  });
}

private groupMessagesByReferenceNumber(messages: Message[]): Message[] {
  const groupedMessages = new Map<string, Message>();
  let latestGeneralMessage: Message | null = null;

  messages.forEach((message) => {
    const moduleName = message.moudle === 'VendorChat' ? 'General' : message.moudle;

    if (moduleName === 'General') {
      // Track the latest General message
      if (!latestGeneralMessage || new Date(message.CreatedAt ?? '') > new Date(latestGeneralMessage.CreatedAt ?? '')) {
        latestGeneralMessage = { ...message, moudle: 'General' };
      }
    } else {
      // Group by module and referenceNumber
      const groupKey = `${moduleName}-${message.referenceNumber || 'NoRef'}`;

      if (groupedMessages.has(groupKey)) {
        const existingMessage = groupedMessages.get(groupKey)!;

        // Retain the latest message in the group
        if (new Date(message.CreatedAt ?? '') > new Date(existingMessage.CreatedAt ?? '')) {
          groupedMessages.set(groupKey, { ...message, moudle: moduleName });
        }
      } else {
        groupedMessages.set(groupKey, { ...message, moudle: moduleName });
      }
    }
  });

  // Add the latest General message to the groupedMessages
  if (latestGeneralMessage) {
    groupedMessages.set('General-NoRef', latestGeneralMessage);
  }

  return Array.from(groupedMessages.values());
}



filterMessages(searchValue: string) {
  const input = searchValue.toLowerCase();

  // Group messages first
  const groupedMessages = this.groupMessagesByReferenceNumber(this.messages);

  // Apply search filtering
  this.filteredMessages = groupedMessages.filter((message) => {
    const isMatchingSearch =
      message.messageContent?.toLowerCase().includes(input) || 
      message.moudle?.toLowerCase().includes(input);

    return isMatchingSearch;
  });

  // Always show "General Chat" or "VendorChat" at the top when search value is empty
  if (input === '') {
    this.filteredMessages.sort((a, b) => {
      const isGeneralA = a.moudle === 'General';
      const isGeneralB = b.moudle === 'General';

      if (isGeneralA && !isGeneralB) {
        return -1; // A comes before B
      } else if (!isGeneralA && isGeneralB) {
        return 1; // B comes before A
      }
      return 0; // No change in order
    });
  }
}




  
  private createApiService(): ApiService {
    const apiService = new ApiService(this._http);
    apiService['_baseUrl'] = environment.API_URL; // Set the base URL manually
    return apiService;
  }
  

  
  

  
  private firePostMessage(apiService: ApiService, payload: any) {
    let req$ = apiService.post(AppConstants.CONTROLLERS.Messages, AppConstants.ACTIONS.sendMessage, true, environment.APIs_PREFIX, payload);
    return lastValueFrom(req$);
  } 



    
  private fireGetMessage(apiService: ApiService) {

    let req$ = apiService.post(AppConstants.CONTROLLERS.Messages, AppConstants.ACTIONS.GetMessages, true, environment.APIs_PREFIX,null);
    return lastValueFrom(req$);
  } 

  


 // Method to format the date as Today/Yesterday or the specific date and time
 formatDate(dateString: string): string {
  const messageDate = new Date(dateString);
  const today = new Date();

  // Check if the message was sent today
  if (messageDate.toDateString() === today.toDateString()) {
    return `Today, ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  }

  // Check if the message was sent yesterday
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  if (messageDate.toDateString() === yesterday.toDateString()) {
    return `Yesterday, ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  }

  // Otherwise, return the full date
  return messageDate.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' }) +
         `, ${messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
}

isMessageSelected(message: Message): boolean {
  if (!this.selectedMessage) {
    return false; // No message selected, nothing to highlight
  }

  // Highlight General (VendorChat) messages
  if (this.selectedMessage.moudle === 'VendorChat' && message.moudle === 'General') {
    return true;
  }

  // Highlight other messages by moudle and referenceNumber
  return (
    this.selectedMessage.moudle === message.moudle &&
    this.selectedMessage.referenceNumber === message.referenceNumber
  );
}


selectMessage(message: Message): void {
  this.selectedMessage = message;
  console.log("Selected Message:", this.selectedMessage);

  // Determine if the message is a "General" message (VendorChat)
  const isGeneral = message.moudle === 'General' || message.moudle === 'VendorChat'; 
  const referenceNumber = message.referenceNumber;

  if (isGeneral) {
    // If it's a general (VendorChat) message, filter all VendorChat messages
    this.relatedMessages = this.messages.filter(
      (msg) => msg.moudle === 'VendorChat'
    );
  } else if (referenceNumber) {
    // For non-VendorChat messages, filter by reference number, module, and subReferenceNumber if it exists
    this.relatedMessages = this.messages.filter((msg) => {
      const matchesReference = msg.referenceNumber === referenceNumber;
      const matchesModule = msg.moudle === message.moudle;
      const matchesSubReference =
        message.subReferenceNumber == null || msg.subReferenceNumber === message.subReferenceNumber;
  
      return matchesReference && matchesModule && matchesSubReference;
    });
  } else {
    // Fallback: No messages match
    this.relatedMessages = [];
  }
  

  // Debugging logs for verification
  console.log("Related Messages:", this.relatedMessages);

  // Scroll to the bottom of the chat
  setTimeout(() => {
    this.scrollToBottom();
  }, 100);
}


formatTime(dateString: string): string {
  const messageDate = new Date(dateString);
  return messageDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}



  

sendMessage() {
  const messageContent = this.form.get('message')?.value; // Get the message input

  if (messageContent && messageContent.trim() !== '') {
    const newMessage: any  = {
      Module: this.selectedMessage?.moudle, // Use the module of the selected message
      vendorID: this.selectedMessage?.vendorID, // Use the vendor ID of the selected message
      subReferenceNumber: this.selectedMessage?.subReferenceNumber, // Sub-reference number
      referenceNumber: this.selectedMessage?.referenceNumber, // Reference number
      messageContent: messageContent,
      CreatedAt: new Date().toISOString(), // Set current time
    };




      const apiService = this.createApiService();

      new Promise((resolve, reject) => {
        this._loaderService.showLoader();

          this.firePostMessage(apiService,newMessage)
          .then((result: any) => {
            let response: BaseResponseDTO = result;
  
            
            if (response?.isSuccess){

              const msgReturned = response.data; // Assuming `response.data` contains the new message from the backend

              // Map the message to the desired format
              const newMessage: any = {
                moudle: msgReturned.moudle, // Map moudle from the response
                vendorID: msgReturned.vendorID, // Map vendorID
                subReferenceNumber: msgReturned.subReferenceNumber, // Map subReferenceNumber
                referenceNumber: msgReturned.referenceNumber, // Map referenceNumber
                messageContent: msgReturned.messageContent, // Map message content
                CreatedAt: new Date(msgReturned.createdAt).toISOString(), // Convert createdAt to ISO string
                CreatedBy: msgReturned.createdBy, // Map createdBy
                ModifiedAt: new Date(msgReturned.modifiedAt).toISOString(), // Convert modifiedAt to ISO string
                ModifiedBy: msgReturned.modifiedBy, // Map modifiedBy
                direction: msgReturned.direction, // Map direction
                id: msgReturned.id, // Map id
              };

              // Add the new message to the list of messages
              this.messages.push(newMessage);


              // Update the relatedMessages array to show the new message immediately
              if (this.selectedMessage?.referenceNumber === newMessage.referenceNumber || 
                (!this.selectedMessage?.referenceNumber && !newMessage.referenceNumber)) {
              this.relatedMessages.push(newMessage);
              }

              // Scroll to the bottom of the chat after adding the message
              setTimeout(() => {
               this.scrollToBottom();
              }, 100);

              // Clear the message input field
              this.form.get('message')?.reset();
            }
          
            resolve(response);
  
          }).catch((err: HttpErrorResponse) => {
              this._loaderService.hideLoader();
          }).finally(() =>{
              this._loaderService.hideLoader();
          });
  
      });
      




  }
}


  //#endregion
 // Method to select a message and filter related messages

}
